var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "acc-page-holder" }, [
    !_vm.mobileBigAndBelow
      ? _c("h1", [_vm._v(_vm._s(_vm.promotionDescription))])
      : _vm._e(),
    _vm._v(" "),
    _vm.mobileBigAndBelow && _vm.brandTemplate !== "generic_2"
      ? _c("div", { staticClass: "account-heading" }, [
          _vm._v("\n    " + _vm._s(_vm.promotionDescription) + "\n  ")
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "ctsform acc-page" }, [
      _c("div", { staticClass: "promotion-banner" }, [
        _c(
          "div",
          {
            staticClass: "promo-img",
            style: [
              {
                backgroundImage:
                  "url(" +
                  _vm.mediaServer("/static/promotions/generic_banner_1.jpg") +
                  ") !important"
              }
            ]
          },
          [
            _c("p", { staticClass: "promotion-title" }, [
              _vm._v(_vm._s(_vm.promotionDescription))
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "promotion-text-generic" }, [
              _vm._v(_vm._s(_vm.$t("Promotions.BaseBannerText")))
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", [_vm._v(_vm._s(_vm.promotionNote))]),
      _vm._v(" "),
      _c("div", [
        _vm._v(
          _vm._s(
            _vm.promotionStartText + " " + _vm.formattedPromotionStart + "."
          )
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-39d77d96", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39d77d96","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/externalintegrations/Free2PlayGamesPromotionInfo.vue
// module id = null
// module chunks = 